import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import ReactHotToaster from "../../../common/ReactHotToaster";

const headCellSx = {
  fontWeight: 700,
  fontSize: "13px",
  color: "#fff",
  background: "#04343a",
  borderBottom: "none",
  padding: "12px 16px",
  whiteSpace: "nowrap",
};

const SubscriptionPlansTable = ({
  plansData = [],
  setOpenSubscriptionForm,
  setActivePlan,
}) => {
  return (
    <Box
      sx={{
        background: "#fff",
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
        overflow: "hidden",
        mb: 3,
      }}
    >
      {/* Section header */}
      <Box sx={{ background: "#04343a", px: "20px", py: "12px", borderTop: "1px solid #eef2f7" }}>
        <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "15px" }}>
          List of Subscription Plans
        </Typography>
      </Box>

      <TableContainer component={Paper} elevation={0} sx={{borderTop: "1px solid #eef2f7"}}>
        <Table>
          <TableHead>
            <TableRow>
              {["Name", "Code", "Description", "Features", "Price", "Period", "Active", "Order", "Actions"].map((label) => (
                <TableCell key={label} sx={headCellSx}>{label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {plansData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center" sx={{ py: 5, color: "#94a3b8" }}>
                  No subscription plans found.
                </TableCell>
              </TableRow>
            ) : (
              plansData.map((item) => (
                <TableRow key={item.id} sx={{ "&:hover": { background: "#f0faf5" } }}>
                  <TableCell>
                    <Typography sx={{ fontWeight: 600, color: "#016551", fontSize: "14px" }}>
                      {item.name}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{item.plan_code}</TableCell>
                  <TableCell sx={{ color: "#64748b", fontSize: "13px", maxWidth: 150 }}>
                    <Tooltip title={item.description} placement="top" arrow>
                      <span style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 140 }}>
                        {item.description}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell sx={{ color: "#64748b", fontSize: "13px", maxWidth: 150 }}>
                    <Tooltip title={item.plan_description} placement="top" arrow>
                      <span style={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 140 }}>
                        {item.plan_description}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{item.price}</TableCell>
                  <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{`${item.interval} ${item.interval_unit}`}</TableCell>
                  <TableCell>
                    <Chip
                      label={item.active ? "Active" : "Inactive"}
                      size="small"
                      sx={{
                        fontWeight: 600,
                        fontSize: "0.7rem",
                        bgcolor: item.active ? "#dcfce7" : "#fee2e2",
                        color: item.active ? "#15803d" : "#b91c1c",
                      }}
                    />
                  </TableCell>
                  <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{item.plan_order}</TableCell>
                  <TableCell>
                    <Tooltip title="Edit" arrow>
                      <IconButton
                        size="small"
                        sx={{ color: "#04343a", "&:hover": { bgcolor: "#e6f4f1" } }}
                        onClick={() => { setOpenSubscriptionForm(true); setActivePlan(item); }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <ReactHotToaster />
    </Box>
  );
};

export default SubscriptionPlansTable;
